import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  getAnalyticsElementDetails,
  initAnalytics,
  trackEvent,
  trackPageView
} from "../analytics";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(`${location.pathname}${location.search}${location.hash}`);
  }, [location]);

  useEffect(() => {
    const handleClick = event => {
      const details = getAnalyticsElementDetails(event.target);

      if (!details) {
        return;
      }

      trackEvent("app_click", {
        ...details,
        page_path: `${window.location.pathname}${window.location.search}${window.location.hash}`
      });
    };

    const handleSubmit = event => {
      trackEvent("app_action", {
        action: "form_submit",
        form_id: event.target.id,
        form_name: event.target.getAttribute("name"),
        page_path: `${window.location.pathname}${window.location.search}${window.location.hash}`
      });
    };

    document.addEventListener("click", handleClick, true);
    document.addEventListener("submit", handleSubmit, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
      document.removeEventListener("submit", handleSubmit, true);
    };
  }, []);

  return null;
};

export default AnalyticsTracker;
